export function client(data) {
    const { limit_max, limit_min, multiple } = data;

    return {
        limitText: limit_max || limit_min,
        maxLength: limit_max ? parseInt(limit_max, 10) : "",
        minLength: limit_min ? parseInt(limit_min, 10) : "",
        multiline: multiple,
    };
}

export function server(data) {
    const { limitText, maxLength, minLength, multiline } = data;

    return {
        limit_max: limitText && parseInt(maxLength, 10) || null,
        limit_min: limitText && parseInt(minLength, 10) || null,
        multiple: multiline ? 1 : 0,
    };
}
